import React, { Component } from 'react';
import axios from 'axios'
import { BrowserRouter, Route,  Navigate } from 'react-router-dom'
import Server from './../Server.js'
import { DataView, DataViewLayoutOptions } from 'primereact/dataview';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { Checkbox } from 'primereact/checkbox';
import { confirmAlert } from 'react-confirm-alert';
import { connect } from 'react-redux';
import { Loader } from 'rsuite';
import { Toast } from "primereact/toast";

class Create_Questions extends React.Component {
  constructor(props) {
    super(props);
    this.Server = new Server();


    this.CreateForm = this.CreateForm.bind(this);
    this.onHideFormsDialog = this.onHideFormsDialog.bind(this);
    this.SetFields = this.SetFields.bind(this);

    this.state = {
      layout: 'list',
      name: "",
      type: "1",
      FId: "",
      DbTableName: "",
      DBTableField: "",
      latinName: "",
      Count: 0,
      CountArr: [],

    }


  }
  componentDidMount() {
    let param = {
      token: localStorage.getItem("api_token"),
    };
    this.setState({
      loading: 1
    })
    let that = this;
    let SCallBack = function (response) {
      that.setState({
        user_Id: response.data.authData.userId,
        loading: 0
      })

      that.GetFields();

    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0
      })
      console.log(error)
    }
    this.Server.send("MainApi/checktoken", param, SCallBack, ECallBack)
  }
  SetFields() {
    let that = this;
    let temp=[];
    for (let i = 0; i < this.state.Count; i++) {
      if (this.state["qTitle_" + i]) {
        temp.push({id:(i+1),title:this.state["qTitle_" + i]});
      }
    }
    let param = {
      token: localStorage.getItem("api_token"),
      _id: this.state.selectedId,
      text: this.state.text,
      type: this.state.type,
      options:this.state.type == "2" ? temp : [],
      num: parseInt(this.state.num)
    };
    this.setState({
      HasErrorForMaps: null,
      loading: 1
    })
    let SCallBack = function (response) {
      that.onHideFormsDialog();
      that.GetFields();
      that.setState({
        loading: 0
      })
     that.toast.current.show({severity:'success', summary: '', detail:'عملیات با موفقیت انجام شد', life: 3000});
    };
    let ECallBack = function (error) {
      console.log(error)
      that.setState({
        loading: 0
      })
      that.toast.current.show({severity:'error', summary: 'خطای سرور', detail:'عملیات انجام نشد', life: 3000});
    }
    this.Server.send("AdminApi/setQuestions", param, SCallBack, ECallBack)
  }
  CreateForm() {
    this.setState({
      visibleManageField: true,
      text: "",
      type: "1",
      num: "",
      Count: 0,
      CountArr: [],
      selectedId: null
    })

  }
  onHideFormsDialog(event) {
    this.setState({
      visibleManageField: false,
      selectedId: null
    });

  }
  onHideMapsDialog(event) {
    this.setState({
      visibleManageMaps: false,
      HasErrorForMaps: null
    });

  }
  selectedComponentChange(value) {
    
    let options={};
    for(let i=0;i<10;i++){
      options["qTitle_"+i] = "";
    }
    for(let i=0;i<value.options.length;i++){
      options["qTitle_"+i] = value.options[i].title;
    }
    this.setState({
      text: value.text,
      type: value.type,
      num: value.num,
      selectedId: value._id,
      CountArr: Array.from(Array(parseInt(value.options.length)).keys()),
      Count:value.options.length,
      visibleManageField: true,
      ...options

    })

  }
  GetFields() {
    let that = this;
    let param = {
      token: localStorage.getItem("api_token"),
      GetAll: 1
    };
    this.setState({
      loading: 1
    })
    let SCallBack = function (response) {

      that.setState({
        GridDataFields: response.data.result
      })
      that.setState({
        loading: 0
      })
    };
    let ECallBack = function (error) {
      console.log(error)
      that.setState({
        loading: 0
      })
    }
    this.Server.send("AdminApi/getQuestions", param, SCallBack, ECallBack)
  }
  delField(rowData) {
    this.setState({
      visibleManageField:false
    })
    confirmAlert({
      title: <span className="yekan">حذف کاربر</span>,
      message: <span className="yekan">  آیا از حذف  {rowData.name} مطمئنید  </span>,
      buttons: [
        {
          label: <span className="yekan">بله </span>,
          onClick: () => {
            let that = this;
            let param = {
              token: localStorage.getItem("api_token"),
              _id: rowData._id,
              del:1
            };
            let SCallBack = function (response) {
              that.setState({
                loading: 0
              })
              that.GetFields();
             that.toast.current.show({severity:'success', summary: '', detail:'عملیات با موفقیت انجام شد', life: 3000});
            };
            let ECallBack = function (error) {
              that.setState({
                loading: 0
              })
              that.toast.current.show({severity:'error', summary: 'خطای سرور', detail:'عملیات انجام نشد', life: 3000});
            }
            this.Server.send("AdminApi/SetFields", param, SCallBack, ECallBack)

          }
        },
        {
          label: <span className="yekan">خیر </span>
        }
      ]
    });

  }

  render() {
    const footer = (
      <div>
        <button className="btn btn-primary irsans" onClick={this.SetFields} style={{ width: "200px", marginTop: "20px", marginBottom: "20px" }}> اعمال </button>

      </div>
    );

    const delTemplate = (rowData, props) => {
      return <i className="fa fa-times" style={{ cursor: 'pointer' }} aria-hidden="true" onClick={() => this.delField(rowData)}></i>;
    }
    return (

      <div style={{ direction: 'rtl' }}>
        {this.state.loading == 1 &&
          <div style={{ position: 'fixed', zIndex: 2000, top: 10, left: 15, backgroundColor: '#e89f31', padding: '2px 20px' }}>
            <Loader content="لطفا صبر کنید ..." className="yekan" />
          </div>
        }
        <div className="row justify-content-center">

          <div className="col-12" style={{ background: '#fff' }}>
            <div className="row" >
              <div className="col-6" style={{ textAlign: 'center' }}>
                <button className="btn btn-primary irsans" onClick={this.CreateForm} style={{ width: "200px", marginTop: "20px", marginBottom: "20px" }}>ساخت فیلد جدید</button>
              </div>

            </div>
            <div className="section-title " style={{ textAlign: 'right' }}><span className="title IRANYekan" style={{ fontSize: 17, color: 'gray' }} >لیست سوالات</span></div>

            <DataTable responsive value={this.state.GridDataFields} selectionMode="single" selection={this.state.selectedComponent} onSelectionChange={e => this.selectedComponentChange(e.value)}>
              <Column field="num" header="شماره سوال" className="irsans" style={{ textAlign: "right" }} />
              <Column field="text" header="متن سوال" className="irsans" style={{ textAlign: "right" }} />
              <Column field="del" body={delTemplate} header="حذف" className="irsans" style={{ textAlign: "right" }} />
            </DataTable>
          </div>

        </div>


        <Dialog header={this.state.selectedId ? "اصلاح" : "ساخت سوال جدید"} visible={this.state.visibleManageField}  footer={footer} minY={70} onHide={this.onHideFormsDialog} maximizable={false} maximized={true}>

            <div className="row" style={{alignItems:'baseline'}}>
              <div className="col-lg-6">
                <div className="group">
                  <input className="form-control irsans" autoComplete="off" type="text" value={this.state.num} name="num" onChange={(event) => this.setState({ num: event.target.value })} required="true" />
                  <label>شماره سوال</label>
                </div>
              </div>
              <div className="col-lg-12">
                <label className="labelNoGroup irsans">نوع</label>
                <select className="form-control irsans" value={this.state.type} name="type" onChange={(event) => this.setState({ type: event.target.value })} style={{ marginBottom: 20 }} >
                  <option value="1">شفاهی</option>
                  <option value="2">چند گزینه ای</option>


                </select>
              </div>
              <div className="col-lg-12">

                <div className="group">
                  <input className="form-control irsans" autoComplete="off" type="text" value={this.state.text} name="text" onChange={(event) => this.setState({ text: event.target.value })} required="true" />
                  <label >متن سوال</label>

                </div>
              </div>
              {this.state.type == "2" &&
              <div className="col-lg-12">
              <button className="btn btn-secondary irsans" onClick={() => {
                let Count = this.state.Count + 1;
                this.setState({
                })
                let that = this;
                let Arr = Array.from(Array(parseInt(Count)).keys())
                that.setState({
                  CountArr: Arr,
                  Count: Count
                })
                return false;
              }
              } style={{ textAlign: 'right', cursor: 'pointer', marginTop: 35 }}><i className="fa fa-plus" /><span style={{ marginRight: 10 }}> اضافه کردن گزینه جدید </span>
              </button>

              <div>
                {this.state.CountArr.map((item, index) => {
                  return (
                    <div className="row" style={{ alignItems: 'baseline' }}>
                      <div className="col-lg-2">
                        <div className="group">
                          <input className="form-control irsans" autoComplete="off" type="text" id={"qTitle_" + index} name={"qTitle_" + index} value={this.state["qTitle_" + index]} onChange={(event) => { this.setState({ ["qTitle_" + index]: event.target.value }) }} required="true" />
                          <label>عنوان</label>
                        </div>
                      </div>
                      
                      <div className="col-lg-1">
                        {this.state.Count == (index + 1) &&
                          <i className="fa fa-minus" style={{ cursor: 'pointer' }} onClick={() => {
                            let Count = this.state.Count - 1;
                            this.setState({
                              Count: Count
                            })
                            let that = this;
                            let Arr = Array.from(Array(parseInt(Count)).keys())
                            that.setState({
                              CountArr: Arr
                            })
                          }} > </i>
                        }

                      </div>

                    </div>
                  )
                })}
              </div>
              </div>
              }
              
              


            </div>
        </Dialog>

      </div>





    )
  }
}
const mapStateToProps = (state) => {
  return {
    systemId: state.systemId,
  }
}
export default connect(mapStateToProps)(Create_Questions);
